import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  tooltip: {
    padding: 0,
  },
  tooltipPlacementBottom: {
    margin: 5,
  },
  arrow: {
    left: 'calc(50% - 14px) !important',
  },
  copyEmailTooltip: {
    userSelect: 'none',
  },
  copyEmailButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    color: theme.palette.common.white,
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
    padding: '4px 16px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  label: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
  },
  tooltipIcon: {
    fill: theme.palette.common.white,
    margin: '0 4px',
    width: 16,
    height: 16,
    display: 'inline-block',
    '&:focus': {
      outline: 0,
    },
  },
}));
